import { Flex, Divider, Typography, Skeleton, List, Card, Button } from 'antd';
import { use, useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faClose, faFlag } from '@fortawesome/free-solid-svg-icons';
import Link from 'antd/es/typography/Link';
import { LoadingOutlined } from '@ant-design/icons';
import GeneralHelper from '../../helpers/general';
import LocationSearch from '../../components/LocationSearch';
import IndexCard from '../../components/IndexCard';
import useIsMobile from '../../helpers/customHooks/useIsMobile';
import hkustLogoIcon from '../../images/hkust-logo-icon.svg';
import ContentDrawer from '../../components/ContentDrawer';

const { Title, Text } = Typography;

const MapPage = (props) => {
	const themeDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
	const { pageProps, getLocations, getLocationsByType, getBuildings, getPointOfInterestTypes, getPointOfInterests, resetPage, getBuildingFloorGeojson, getBuildingFloorNavNodes } = props;
	const { locations, loadingLocType, filteredLocations, loading, buildings, total } = pageProps;
	const query = GeneralHelper.getParamsFromUrl();
	const [searchWords, setSearchWords] = useState([]);
	const [page, setPage] = useState(1);
	const [data, setData] = useState([]);
	const history = useHistory();

	const drawerContainerRef = useRef(null);

	const isMobile = useIsMobile();
	const [isSearchClicked, setIsSearchClicked] = useState(!isMobile);

	const indexOnClick = (data) => {
		const { _id, building_floor_id } = data || {};
		let query = { id: _id };

		if (building_floor_id && GeneralHelper.isObjectId(building_floor_id._id))
			query = { id: _id, building_floor_id: building_floor_id._id };

		const queryString = GeneralHelper.objectToQueryString(query);
		history.push(`location/id?${queryString}`);
	};

	useEffect(() => {
		if (query.keyword && GeneralHelper.isObjectId(query.building_floor_id)) {
			getBuildingFloorGeojson({ building_floor_id: query.building_floor_id });
			getBuildingFloorNavNodes({ building_floor_id: query.building_floor_id });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query.building_floor_id]);

	const loadMore = () => {
		if (query.keyword && !_.isNil(query.keyword)) {
			const searchParams = {
				keyword: query.keyword,
				page,
				limit: 50 
			};
			if (query.id) {
				searchParams.building_id = query.id;
			}
			if (query.building_floor_id) {
				searchParams.building_floor_id = query.building_floor_id;
			}
			getLocationsByType(searchParams);
		}
	};

	useEffect(() => {
		getPointOfInterestTypes();
		getPointOfInterests();
		// getBuildings({ page: 1, limit: 20 });
		// console.log('fetching a');
	}, []);

	// useEffect(() => {
	// 	setPage(1);
	// 	setData([]);
	// 	if (!isMobile) {
	// 		if (query.search && !_.isNil(query.search)) {
	// 			getLocations({ search: query?.search || '', page: 1, limit: isMobile ? 999 : 20 }, isMobile);
	// 			console.log('searching', 69, isMobile);
	// 			setSearchWords([...query.search]);
	// 		}
	// 	}
	// }, [isMobile]);

	useEffect(() => {
		setPage(1);
		setData([]);

		if (query.keyword && !_.isNil(query.keyword)) {
			const searchParams = {
				keyword: query.keyword,
				page: 1,
				limit: 50
			};
			if (query.id) {
				searchParams.id = query.id;
			}
			if (query.building_floor_id) {
				searchParams.building_floor_id = query.building_floor_id;
			}
			getLocationsByType(searchParams);
		} else {
			getBuildings({ page: 1, limit: 20 });
		}

		return () => resetPage();
	}, [query.keyword, query.id, query.building_floor_id, getLocationsByType, getBuildings, resetPage]);

	useEffect(() => {
		if (!query.keyword) {
			setData(buildings);
			setPage(1);
			return;
		}

		// if (buildings && !query.keyword) {
		// 	setData(state => [...state, ...buildings]);
		// 	setPage(page + 1);
		// }

		if (filteredLocations && query.keyword) {
			setData(state => [...state, ...filteredLocations]);
			setPage(page + 1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [buildings, filteredLocations, query.keyword]);

	// ANCHOR Components
	const renderDrawerTitle = () => {
		return (
			<Title
				className="content-body-prompt opaque"
				level={5}
				style={{ marginBlockEnd: 0 }}
			>
				{
					(loading || loadingLocType) ? 'Loading locations...' :
						query.keyword && (filteredLocations && !filteredLocations.length) ? `No ${query.keyword}/s found`
							: buildings ? 'Buildings' : 'Locations'
				}
			</Title>
		);
	};

	return (
		<>
			<div
				className="content-drawer-container"
				id={!isMobile ? 'scrollable-content' : undefined}
				ref={drawerContainerRef}
			>
				<ContentDrawer
					nudge
					nudgeDistance={60}
					peekRows={1.5}
					rowSelector=".search-index"
					title={renderDrawerTitle}
					goBack={filteredLocations && filteredLocations.length ? () => history.push('/') : undefined}
					handleLabel={loadingLocType ? <><LoadingOutlined /> Finding {query?.keyword ? query.keyword : 'Locations'}</> : loading ? <LoadingOutlined /> : (filteredLocations && filteredLocations.length) && query?.keyword ? <>Locations - {query.keyword}</> : 'Buildings'}
					drawerProps={{
						getContainer: () => drawerContainerRef.current
					}}
				>

					{!isMobile &&
						<Title
							className="content-prompt opaque"
							level={5}
						>
							{
								(loading || loadingLocType) ? 'Loading locations...' :
									query.keyword && (filteredLocations && !filteredLocations.length) ? `No ${query.keyword}/s found`
										: buildings ? 'Buildings' : 'Locations'
							}
						</Title>
					}
					<div className="hkust content">
						{/* <div className="content-head">
					<LocationSearch
						style={{ flex: 1 }}
						className="hkust location-seach"
						loading={loading}
						value={query?.search}
						onClick={() => setIsSearchClicked(true)}
						onClear={() => setIsSearchClicked(false)}
					// logo={isMobile && hkustLogoIcon}
					/>
				</div> */}
						<div
							className="content-body"
						>
							{
								(data && data.length) ?
									<InfiniteScroll
										className="content-inner"
										dataLength={data.length}
										next={loadMore}
										hasMore={filteredLocations && data.length < total}
										scrollableTarget="scrollable-content"
										endMessage={null}
										loader={
											<Card>
												<Skeleton
													paragraph={{ rows: 1 }}
													active
												/>
											</Card>
										}
									>
										<List
											dataSource={data}
											renderItem={item => (
												<IndexCard
													data={item}
													key={item._id}
													searchWords={searchWords}
													onClick={() => indexOnClick(item)}
												/>
											)}
										/>
									</InfiniteScroll> : null
							}

						</div>
					</div>
				</ContentDrawer>
			</div>
		</>
	);
};

export default MapPage;